import Link from '@mui/material/Link';
import { Navigate, useNavigate } from 'react-router';
import { useLogout, useMe } from '../../api/auth';
import { AuthLayout } from '../../components/layout/AuthLayout';
import { useToast } from '../../components/Toast';
import { ChangePasswordForm } from './ChangePasswordForm';

/** After signing in with a temporary password: change it before anything else. */
export function ForcedChangePasswordPage() {
  const { data: me } = useMe();
  const logout = useLogout();
  const navigate = useNavigate();
  const toast = useToast();
  if (me && !me.mustChangePassword) return <Navigate to="/" replace />;
  return (
    <AuthLayout title="Choose your own password." lead="You signed in with a temporary password. Choose one only you know to carry on.">
      <ChangePasswordForm
        submitLabel="Save and continue"
        onDone={() => {
          toast('Your password has been changed.');
          navigate('/', { replace: true });
        }}
      />
      <Link component="button" type="button" onClick={() => logout.mutate(undefined, { onSettled: () => navigate('/sign-in', { replace: true }) })} sx={{ mt: 3 }}>
        Sign out instead
      </Link>
    </AuthLayout>
  );
}
